import interactions from '@gov.wa.lni/application.isolated-workers-complaint/source/interactions';
import components from '@gov.wa.lni/application.isolated-workers-complaint/source/components';

import ApplicationMain from '@gov.wa.lni/application.isolated-workers-complaint/source/application-main.vue';
import HomePage from '@gov.wa.lni/application.isolated-workers-complaint/source/pages/home.page.vue';
import ConfirmationPage from '@gov.wa.lni/application.isolated-workers-complaint/source/pages/confirmation.page.vue';

import store from '@gov.wa.lni/application.isolated-workers-complaint/source/store.js';

const options = {
    addAccessibleRouting: true,
    components: {
        ApplicationMain,
    },
    applicationComponents: [
        ...components,
    ],
    applicationActions: interactions,
};

const routes = [
    {
        path: '/',
        name: 'IwcForm',
        component: HomePage,
        meta: {
            title: 'Isolated Workers Complaint',
        },
    },
    {
        path: '/confirmation',
        name: 'ConfirmationPage',
        component: ConfirmationPage,
        meta: {
            title: 'Confirmation',
        },
    },
];
options.routing = {
    routes,
    navigationGuards: {
        beforeEach: (store, to, from, next) => {
            if (to.path === '/') {
                next();
                return;
            }

            const isInitialized = !!store.state.appState?.isInitialized;
            if (!isInitialized) {
                next('/');
                return;
            }

            store.commit('appState/SET_VALUE', {
                key: 'isLoading',
                value: true,
            });

            next();
        },
    },
};

window.lni.oneLniCorePlugin.initialize(
    options,
    configuration => {
        window.lni.Vue.use(window.lni.oneLniCorePlugin);
        const application = new window.lni.Vue(configuration);
        window.lni.oneLniCorePlugin.setApplication(application);
        application.$store.registerModule('appState', store);
    },
);